import { Object } from "core-js";

export default Object.freeze({
    MissedDelivery: '/missed-delivery',
    Confirmation: '/confirmation',
    PreDeliveryRedirection: '/predelivery-redirection/:predeliveryRequestGuid'
});